export default {
  state: ()=>{
    return {
      visitedViews:[],
      cachedViews:[]
    }
  },
  mutations: {
 
    addTagVIew (state,view) {
      this.commit('addVisitedView',view)
      this.commit('addCachedView',view)

      // this.addVisitedView(state,view);
      // this.addCachedView(state,view);
    },
 
    addVisitedView (state,view) {
      console.log("addVisitedView", state.visitedViews, view);
      // 如果已经存在于已访问的视图列表中，则不再添加
      if (state.visitedViews.some((v) => v.fullPath === view.fullPath)) {
        return;
      }
      // 如果视图是固定的（affix），则在已访问的视图列表的开头添加
      if (view.affix) {
        state.visitedViews.unshift(view);
      } else {
        // 如果视图不是固定的，则在已访问的视图列表的末尾添加
        state.visitedViews.push(view);
      }
    },
    addCachedView(state,view) {
      console.log("addCachedView", state.cachedViews, view);
      const viewName = view.name;
      // 如果缓存视图名称已经存在于缓存视图列表中，则不再添加
      if (state.cachedViews.includes(viewName)) {
        return;
      }
      // 如果视图需要缓存（keepAlive），则将其路由名称添加到缓存视图列表中
      // if (view.keepAlive) {
        state.cachedViews.push(viewName);
      // }
    },
  
     /**关闭视图 */
     delView(state,view){
      return new Promise((resolve)=>{
        for (const [i, v] of state.visitedViews.entries()) {
          // 找到与指定视图路径匹配的视图，在已访问视图列表中删除该视图
          if (v.path === view.path) {
            state.visitedViews.splice(i, 1);
            break;
          }
        }
        resolve()
      });
    },
    /**关闭其他视图 */
    delOtherViews(state,view){
        this.commit('delOtherVisitedViews',view)
        this.commit('delOtherCachedViews',view)
    },
    delCachedView(state,view){
      const viewName = view.name;
      return new Promise((resolve) => {
        const index = state.cachedViews.indexOf(viewName);
        index > -1 && state.cachedViews.splice(index, 1);
        resolve();
      });
    },
    delVisitedViews(view){

    },

    delOtherVisitedViews(state,view){
        state.visitedViews =  state.visitedViews.filter((v) => {
          return v.path === view.value.path;
        });
        console.log("delOtherVisitedViews", state.visitedViews);
    },
    delOtherCachedViews(state,view){
        state.cachedViews =  state.cachedViews.filter((v) => {
          return v === view.value.name;
      });
      console.log("delOtherCachedViews", state.cachedViews);
    },
    clearTagView(state){
      state.visitedViews=[]
      state.cachedViews=[]
    },
    initTagView(state){
      
    }
  },
  actions: {
    addTagVIew (store,view) {
      store.commit('addTagVIew',view)
    },
     /**关闭视图 */
     delView(store,view){
      store.commit('delView',view)
    },
    /**关闭视图 */
    delCachedView(store,view){
      store.commit('delCachedView',view)
    },
    /**关闭其他视图 */
    delOtherViews(store,view){
      store.commit('delOtherViews',view)
    },
    clearTagView(store){
      store.commit('clearTagView');
    },
    initTagView(store){
      store.commit('clearTagView');
    }

  },
  getters: {

  }
};


